import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie, X } from "lucide-react";

const STORAGE_KEY = "aa_consent";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const v = localStorage.getItem(STORAGE_KEY);
      if (!v) setVisible(true);
    } catch (e) { /* localStorage blocked */ }
  }, []);

  const accept = () => {
    try { localStorage.setItem(STORAGE_KEY, "accepted"); } catch (e) {}
    // Unlock GA (Consent Mode)
    if (typeof window.gtag === "function") {
      window.gtag("consent", "update", {
        ad_storage: "granted",
        ad_user_data: "granted",
        ad_personalization: "granted",
        analytics_storage: "granted",
      });
    }
    // Activate Meta Pixel
    if (typeof window.fbq === "function" && !window.__aaPixelOn) {
      window.fbq("init", "1978489923031456");
      window.fbq("track", "PageView");
      window.__aaPixelOn = true;
    }
    setVisible(false);
  };

  const decline = () => {
    try { localStorage.setItem(STORAGE_KEY, "declined"); } catch (e) {}
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      role="dialog"
      aria-label="Cookie-Hinweis"
      data-testid="cookie-banner"
      className="fixed inset-x-0 bottom-0 z-[60] p-3 sm:p-4 animate-fade-up"
    >
      <div className="max-w-4xl mx-auto bg-ink text-sand rounded-lg shadow-2xl border border-white/10 p-5 sm:p-6">
        <div className="flex items-start gap-4">
          <Cookie className="w-6 h-6 text-terracotta-soft shrink-0 mt-0.5" strokeWidth={1.5} />
          <div className="flex-1 min-w-0">
            <h3 className="font-display text-lg">Cookies & Datenschutz</h3>
            <p className="mt-2 text-sm text-sand/80 leading-relaxed">
              Wir verwenden Cookies, um unsere Webseite zu verbessern und die Nutzung zu analysieren
              (Google Analytics, Meta Pixel). Notwendige Cookies sind immer aktiv. Du kannst die
              optionalen Cookies jederzeit ablehnen.{" "}
              <Link to="/datenschutz" className="underline hover:text-white">
                Mehr in der Datenschutzerklärung
              </Link>
              .
            </p>
            <div className="mt-4 flex flex-wrap gap-2">
              <button
                onClick={accept}
                data-testid="cookie-accept"
                className="px-5 py-2.5 bg-terracotta text-white rounded-full text-sm hover:bg-terracotta-hover transition"
              >
                Alle akzeptieren
              </button>
              <button
                onClick={decline}
                data-testid="cookie-decline"
                className="px-5 py-2.5 border border-sand/30 text-sand rounded-full text-sm hover:bg-white/5 transition"
              >
                Nur notwendige
              </button>
            </div>
          </div>
          <button
            onClick={decline}
            aria-label="Schliessen"
            className="p-1.5 -mr-1 text-sand/60 hover:text-sand"
          >
            <X className="w-4 h-4" strokeWidth={1.5} />
          </button>
        </div>
      </div>
    </div>
  );
}
